export default __webpack_public_path__ + "static/media/react.97d9a9b0.png";